import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const groups = [
  [
    {
      id: "e08847e8-f59f-43ef-902b-314a7e58c68c",
      content: "play sound",
      options: { clickAudioUrl: `${config.ASSETS_URL}/02/12/task/task-2-sound-1.wav` },
    },
    {
      id: "cbdd3cc6-8cf1-42e7-89f5-efa4137d7415",
      content: "play sound",
      options: { clickAudioUrl: `${config.ASSETS_URL}/02/12/task/task-2-sound-2.wav` },
    },
    {
      id: "1c4844b1-e93a-4dec-9274-339598f7cf91",
      content: "play sound",
      options: { clickAudioUrl: `${config.ASSETS_URL}/02/12/task/task-2-sound-3.wav` },
    },
  ],
  [
    {
      id: "5d34901a-1473-41c2-9948-e93f55e7d970",
      options: { imageUrl: `${config.ASSETS_URL}/02/12/task/task-2-head-1.svg` },
    },
    {
      id: "e787c70e-32a9-4bc2-97af-6c83197346b7",
      options: { imageUrl: `${config.ASSETS_URL}/02/12/task/task-2-head-2.svg` },
    },
    {
      id: "e5e93c05-76ce-405e-9e8e-da09935e7066",
      options: { imageUrl: `${config.ASSETS_URL}/02/12/task/task-2-head-3.svg` },
    },
  ],
  [
    {
      id: "84fac94b-22fc-4b11-9bb0-623df6946d97",
      content: "T<sub>Left</sub> < T<sub>Right</sub><br>L<sub>Left</sub> > L<sub>Right</sub>",
      options: {},
    },
    {
      id: "d8eb67e1-a45a-4399-915b-9a34bd313ece",
      content: "T<sub>Left</sub> > T<sub>Right</sub><br>L<sub>Left</sub> < L<sub>Right</sub>",
      options: {},
    },
    {
      id: "ab0294de-f4ff-4a56-a6ab-3c92038cf3a2",
      content: "T<sub>Left</sub> = T<sub>Right</sub><br>L<sub>Left</sub> = L<sub>Right</sub>",
      options: {},
    },
  ],
];

export const task: Task = {
  id: "567b435c-262b-4177-a090-009785f45f28",
  solutionType: "connect",
  type: "connectWithLineMultipleColumns",
  options: {
    shuffle: false,
    multipleConnection: false,
  },
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "connect",
  data: [
    { sourceId: "e08847e8-f59f-43ef-902b-314a7e58c68c", targetId: "5d34901a-1473-41c2-9948-e93f55e7d970" },
    { sourceId: "cbdd3cc6-8cf1-42e7-89f5-efa4137d7415", targetId: "e787c70e-32a9-4bc2-97af-6c83197346b7" },
    { sourceId: "1c4844b1-e93a-4dec-9274-339598f7cf91", targetId: "e5e93c05-76ce-405e-9e8e-da09935e7066" },

    { sourceId: "5d34901a-1473-41c2-9948-e93f55e7d970", targetId: "ab0294de-f4ff-4a56-a6ab-3c92038cf3a2" },
    { sourceId: "e787c70e-32a9-4bc2-97af-6c83197346b7", targetId: "84fac94b-22fc-4b11-9bb0-623df6946d97" },
    { sourceId: "e5e93c05-76ce-405e-9e8e-da09935e7066", targetId: "d8eb67e1-a45a-4399-915b-9a34bd313ece" },
  ],
};
